import script from "./TransitionsEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransitionsEdit.vue?vue&type=script&setup=true&lang=ts"

import "./TransitionsEdit.vue?vue&type=style&index=0&id=01b9143a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b9143a"]])

export default __exports__